/**
 * Student utility functions
 */

export interface StudentLike {
  firstName?: string
  middleName?: string
  lastName?: string
  displayName?: string
}

/**
 * Get the display name for a student.
 * Prefers the server-computed displayName (which is settings-driven),
 * falls back to combining name parts if displayName is not available.
 */
export function getStudentDisplayName(student: StudentLike | undefined | null): string {
  if (!student) return ''

  // Prefer server-computed displayName
  if (student.displayName) {
    return student.displayName
  }

  // Fallback: combine name parts
  return [student.firstName, student.middleName, student.lastName].filter(Boolean).join(' ') || ''
}

/**
 * Get initials from a student's name.
 * Uses displayName if available, otherwise combines name parts.
 */
export function getStudentInitials(student: StudentLike | undefined | null): string {
  const name = getStudentDisplayName(student)
  if (!name) return '?'

  const parts = name.split(' ')
  return parts
    .map((p) => p[0]?.toUpperCase() || '')
    .slice(0, 2)
    .join('')
}
